import React from 'react';

const CheckmarkIcon = ({ size = 15, color = '#0A84FF' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <path
        d="M5.76904 14.5596C5.3042 14.5596 4.95557 14.3853 4.64014 13.9951L0.340332 8.69922C0.0996094 8.40869 0 8.13477 0 7.84424C0 7.18018 0.489746 6.69873 1.17041 6.69873C1.57715 6.69873 1.85938 6.84814 2.1333 7.18848L5.73584 11.7539L12.7666 0.614258C13.0488 0.166016 13.3311 0 13.7959 0C14.4683 0 14.9497 0.473145 14.9497 1.12891C14.9497 1.38623 14.875 1.65186 14.6758 1.95068L6.90625 13.9702C6.64062 14.3687 6.25879 14.5596 5.76904 14.5596Z"
        fill={color}
      />
    </svg>
  );
};

export default CheckmarkIcon;
